var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoJeffersonCarvalho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27C11.7791 27 10.0502 26.4198 8.81325 25.2593C7.60442 24.0989 7 22.4226 7 20.2307V18.49H10.7108V20.4241C10.7108 22.7192 11.8072 23.8668 14 23.8668C16.1928 23.8668 17.2892 22.7192 17.2892 20.4241V0H21V20.2307C21 22.4226 20.3815 24.0989 19.1446 25.2593C17.9357 26.4198 16.2209 27 14 27Z",
    fill: "#BF98FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H27.4737C27.7644 0 28 0.137754 28 0.307692V2H18V0Z",
    fill: "#BF98FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.307692C0 0.137754 0.252557 0 0.564103 0H11V2H0V0.307692Z",
    fill: "#BF98FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.9277H28V33.62C28 33.79 27.7468 33.9277 27.4343 33.9277H0.565657C0.253254 33.9277 0 33.79 0 33.62V31.9277Z",
    fill: "#BF98FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2V33H26V2H28Z",
    fill: "#BF98FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V33H0L7.46456e-07 2H2Z",
    fill: "#BF98FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJeffersonCarvalho);
export default __webpack_public_path__ + "static/media/logo-jefferson-carvalho.1ab59b0fbd900fd305989d3067404dd0.svg";
export { ForwardRef as ReactComponent };